import { VideoPlayerType } from '../../_common/client/types';

export class CliplisterSettings {
    public static getViewerUrl(videoPlayerType: VideoPlayerType): string {
        if (videoPlayerType === 'OTTO_live') {
            return `https://www.otto.de/static-proxy/product-assets/cliplister-player.js`;
        }
        if (videoPlayerType === 'OTTO_nonlive') {
            return `https://develop.otto.de/static-proxy/product-assets/cliplister-player.js`;
        }
        const queryStringItems = [
            'cliplister=86605.2',
            'clViewer=86605.18',
            'videostage=86605.15',
            'innercontrols=86605.4',
            'clickablevideo=86605.3',
            'bufferingspinner=86605.3',
            'nextbutton=86605.4',
            'previewimage=86605.3',
            'playbutton=86605.1',
            'autoplaynext=86605.5',
        ];
        return `https://cdn19.mycliplister.com/media019/merge?${queryStringItems.join('&')}`;
    }

    public static buildViewerConfig(assetKey: string, parentId: string, assetRatioLandscape = false) {
        const stageConfig = {
            width: '100%',
            aspectRatio: assetRatioLandscape ? '16:9' : '9:16',
        };

        return {
            parentId: parentId,
            customer: 86605,
            assetKeys: [assetKey],
            keyType: 10000,
            backgroundColor: '#000000',
            autoplay: false,
            defaultQuality: 'auto',
            assetLimit: 2, // maximum of two videos
            stage: stageConfig,
            plugins: {
                ClickableVideo: {
                    layer: 1,
                },
                InnerControls: {
                    breakpoints: {
                        s: 447,
                    },
                    layer: 2,
                    id: 'controls',
                    blacklist: ['playback-speed', 'share'],
                    template: {
                        type: 'external',
                        source: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/2018/controls-otto-live.html',
                    },
                },
                BufferingSpinner: {
                    layer: 3,
                },
                PreviewImage: {
                    layer: 4,
                },
                PlayButton: {
                    id: 'playButton',
                    layer: 5,
                    image: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/img/playButton_otto2.png',
                    width: 72,
                    height: 72,
                },
                NextButton: {
                    id: 'nextButton',
                    layer: 6,
                    timeAfterStart: 10,
                    timeTillEnd: 10,
                    visibility: 'mouseover',
                    template: 'https://cdn19.mycliplister.com/media019/static/viewer/assets/skins/otto/2018/next-button-otto.html',
                    breakpoints: {
                        s: 447,
                    },
                    position: {
                        top: 8,
                        right: 8,
                    },
                },
                AutoplayNext: {
                    layer: 7,
                    wait: 5,
                },
            },
        };
    }
}
